import React from 'react'

import './TagCloud.scss'

const TagCloud = props => {
  const {
    tagCloud = [],
    handleTag,
    componentName = 'SupportTagCloud',
    activeTab,
    showActiveState = true,
  } = props

  return (
    <div className={`${componentName}`}>
      {(Array.isArray(tagCloud) ? tagCloud : []).map(tagCloudItem => (
        <div
          className={`${componentName}__tagItem ${
            showActiveState && activeTab && activeTab === tagCloudItem.id
              ? `${componentName}__tagItem__active`
              : ''
          }`}
          key={`${tagCloudItem.description}+${tagCloudItem.id}`}
          onClick={() => handleTag(tagCloudItem.id)}
          role="button"
          tabIndex={0}
          aria-pressed={showActiveState && activeTab === tagCloudItem.id}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleTag(tagCloudItem.id)
            }
          }}
        >
          <h5>{tagCloudItem.category}</h5>
        </div>
      ))}
    </div>
  )
}

export default TagCloud
